


















import { defineComponent, ref } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { FragmentFields } from "@scrile/api-provider/dist/api/types";
import { useCreditCardAssignment } from "@/hooks/useCreditCardAssignment";
import useSystemSettings from "@/hooks/useSystemSettings";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import CardListView from "./components/CardListView";

const CREDIT_CARD_FIELDS: FragmentFields<CreditCardAssignment> = ["id", "paymentSystemId", "cardNumberEnding", "type"];
export default defineComponent({
  name: "PagePaymentCards",
  components: { CardListView, BasePage, BaseConfirm, BaseButton, PageTitle },
  setup(_, { root }) {
    const { creditCardAllowed } = useSystemSettings();
    const { creditCards, getCreditCardAssignment } = useCreditCardAssignment();
    const loading = ref(false);
    const showConfirm = ref(false);
    const removerLoading = ref(false);
    const removedCard = ref<CreditCardAssignment>();

    const removeCard = async () => {
      if (creditCards.value.length === 0 || !removedCard.value) return;
      try {
        removerLoading.value = true;
        await providers.CreditCardAssignmentsProvider.delete({ id: removedCard.value.id });
        await getCreditCardAssignment(CREDIT_CARD_FIELDS);
        showConfirm.value = false;
      } finally {
        removerLoading.value = false;
      }
    };

    const handleRemoveCard = (card: CreditCardAssignment) => {
      showConfirm.value = true;
      removedCard.value = card;
    };

    const checkAndGetData = async () => {
      if (!creditCardAllowed.value) {
        root.$router.push("/");
        return;
      }

      try {
        loading.value = true;
        await getCreditCardAssignment(CREDIT_CARD_FIELDS);
      } finally {
        loading.value = false;
      }
    };

    checkAndGetData();
    return {
      removeCard,
      removedCard,
      handleRemoveCard,
      loading,
      showConfirm,
      removerLoading,
      creditCards,
    };
  },
});
